import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Address from '../../entities/address';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteAddress(): boolean {
return true;
}
export function collectAddressDeleteImpact(address: Address, context: DeleteImpactContext): void {
const key = 'address:' + address.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
}
export function deleteImpactAddress(address: Address): DeleteImpact {
const context = deleteImpactContext();
collectAddressDeleteImpact(address, context);
return deleteImpactCounts(context);
}
export function deleteAddress(address: Address, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteAddress()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectAddressDeleteImpact(address, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || address.id};
}
const key = 'address:' + address.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));

const deleted = address.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.AddressActions.removeAddressQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}
